import { render, staticRenderFns } from "./QuickMenu.vue?vue&type=template&id=3afedcfc"
import script from "./QuickMenu.vue?vue&type=script&lang=js"
export * from "./QuickMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports